import React from "react";
import { BarChart3, ExternalLink, Link2, Pencil } from "lucide-react";
import { SmartLink } from "@/services/bedrock";
import { Button } from "@/components/ui";

interface Props {
  smartLink: SmartLink;
  onStatsClick?: () => void;
  onEditClick?: () => void;
}

export function SmartLinkCard({ smartLink, onStatsClick, onEditClick }: Props) {
  return (
    <div className="flex gap-3 p-3 rounded-lg bg-white border border-slate-200 shadow-sm">
      <div className="p-2 rounded-md">
        <Link2 className="size-4 text-primary" />
      </div>
      <div className="flex flex-col min-w-0 flex-1">
        <div className="flex items-center gap-1.5 min-w-0">
          <span className="font-semibold text-sm">{smartLink.name}</span>
          <a
            href={smartLink.destinationUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-primary transition-colors"
          >
            <ExternalLink className="size-3" />
          </a>
        </div>
        <span className="text-xs text-muted-foreground">{smartLink.destinationUrl}</span>
      </div>
      <div className="flex items-center gap-1">
        {onEditClick && (
          <Button variant="ghost" size="icon" className="size-8" type="button" onClick={onEditClick}>
            <Pencil className="size-4" />
          </Button>
        )}

        {onStatsClick && (
          <Button variant="ghost" size="icon" className="size-8" type="button" onClick={onStatsClick}>
            <BarChart3 className="size-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
